// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/EditPreferences/Content/Main/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_EditPreferences_Content_Main_Content($id: uuid!, $properties: jsonb!) {
  update_apps_connection_resources_by_pk(
    pk_columns: { id: $id }
    _set: { properties: $properties }
  ) {
    id
    connection_id
    resource_id
    properties
  }
}

`